import { stringToEnum } from '@snap-types/models/common';

export enum CalculationMode {
  DEFAULT = 'default',
  BATCH_WEIGHT = 'batch-weight',
  BATCH_QUANTITY = 'batch-quantity',
  LOT = 'lot',
}

export const calculationModeSchema = stringToEnum(CalculationMode);
